import { Button, Card, CardContent, CardHeader, CardTitle } from '@vantage-hub/ui'
import { useNavigate } from '@tanstack/react-router'

export function LoginPage() {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-background)] p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-center text-2xl">Certificate Portal</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-center text-[var(--color-muted-foreground)] text-sm">
            Sign in to access your certificates
          </p>
          <Button onClick={() => void navigate({ to: '/' })} className="w-full">
            Sign In (Demo)
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
